import { gql } from "@apollo/client";

export const REVOKE_DELIVERY = gql`
    mutation DeliveryMutation($trackingNumber: String!, $revokeReason: DeliveryRevokeReason!) {
        revokeDelivery(trackingNumber: $trackingNumber, revokeReason: $revokeReason)
    }
`;

export interface RevokeDeliveryVariables {
    trackingNumber: string;
    revokeReason: string;
}

export interface RevokeDeliveryResponse {
    revokeDelivery: boolean;
}
